import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Query as QueryComponent} from "../"

import reportFields from "../../gql/report"


export const cycleQuery = gql`
  query Report(
    $uuid: String!
  ) {
    report(uuid: $uuid) {
      ${reportFields}
    }
  }`

const ReportQuery = ({children, ...props}) => {
  return (
    <QueryComponent
      {...props}
      query={cycleQuery}>
      {({data: {report} = {}, ...apolloState}) => {
        return children({report, ...apolloState})
      }}
    </QueryComponent>
  )
}

ReportQuery.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    uuid: PropTypes.string.isRequired
  }).isRequired
}


export default ReportQuery
